<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// 应用根组件
</script>

<style>
#app {
  min-height: 100vh;
  background-color: #fff8ea;
}
</style>
